import React, { useMemo, useEffect } from 'react'

import GroupAttrContent from './GroupAttrContent'
import NormalAttrContent from './NormalAttrContent'
import SpecsContent from './SpecsContent'

import styles from './index.module.less'
import { groupBy } from '../../utils'

export default function ProductAttrBox({ product, callback }) {
    // const attrRows = useMemo(() => {
    //     const { attrs = [] } = product
    //     if (attrs.length > 0 && attrs[0].groupName) {
    //         return attrs[0].groupName.split('@@')
    //     }
    //     return []
    // }, [product])

    const getAttrRows = useMemo(() => {
        const { attrs = [] } = product

        const groupArr = attrs.filter(item => item.groupKey)
        const noGroupArr = attrs.filter(item => !item.groupKey)
        const groupObj = groupBy(groupArr, 'groupName')
        // console.log(groupObj, '////====groupObj====', noGroupArr)
        return { groupObj, normalArr: noGroupArr }
    }, [product])

    const { groupObj = {}, normalArr = [] } = getAttrRows

    return (
        <div>
            <SpecsContent product={product} />
            {
                <div className={styles.productAttrWrapper}>
                    {
                        Object.keys(groupObj).length > 0 && (
                            <GroupAttrContent product={product} groupAttrRows={groupObj} />
                        )
                    }

                    {
                        normalArr.length > 0 && (
                            <NormalAttrContent product={product} normalArr={normalArr} />
                        )
                    }
                </div>

            }
        </div>
    )
}
